module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/backtop.8b3a2d97.png";